<app-card [showHeader]="false" [padding]="0" [style.display]="!showCreate ? '' : 'none'">
  <div class="row p-t-25">
    <div class="p-b-15">
      <app-base-page-tools [service]="serviceInstance" [fieldsConfigService]="fieldsConfigService" [canCreate]="canCreate"></app-base-page-tools>
    </div>
    <div class="p-b-15">
      <app-base-criteria>
        <ng-content select="[criteria]"></ng-content>
      </app-base-criteria>
    </div>
    @if(permissions?.access) {
      <div class="col-12">
        <!-- <app-card> -->
        <div class="" padding="0">
          <div class="p-b-15">
            <app-base-grid
            [canEdit]="canEdit"
            [canDelete]="canDelete"
              [service]="serviceInstance"
              [fieldsConfigService]="fieldsConfigService"
              [formComponent]="formComponent"
              [disableActionsFieldName]="disableActionsFieldName"
              [disableActionsValue]="disableActionsValue"
            ></app-base-grid>
          </div>
        </div>
        <!-- </app-card> -->
      </div>
    }
  </div>
</app-card>

<div [style.display]="showCreate ? '' : 'none'">
  <app-base-create [service]="serviceInstance" [fieldsConfigService]="fieldsConfigService" [canCreate]="canCreate"
  [canEdit]="canEdit">
    <ng-content select="[form]"></ng-content>
  </app-base-create>
</div>
